import { styled } from '@mui/material'
import { ReactComponent as SvgClose } from 'assets/toast/close.svg'
import { ReactComponent as SvgError } from 'assets/toast/toast_error.svg'
import { ReactComponent as SvgInfo } from 'assets/toast/info.svg'
import { ReactComponent as SvgSuccess } from 'assets/toast/toast_success.svg'
import { ReactComponent as SvgWarning } from 'assets/toast/toast_warning.svg'
import { toast, ToastOptions } from 'react-hot-toast'

const ToastWrap = styled('div')`
  display: flex;
  align-items: center;
  max-width: 320px;
  padding: 8px 6px;
  color: rgba(200, 197, 197, 1);
  svg {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    margin-right: 16px;
    /* vertical-align: top; */
  }
  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 3px;
    left: 0;
    bottom: 0;
  }

  &.error {
    ::after {
      background-color: rgba(240, 67, 73, 1);
      box-shadow: 0 0 5px rgba(240, 67, 73, 1);
    }
  }

  &.warn {
    ::after {
      background-color: rgba(255, 210, 31, 1);
      box-shadow: 0 0 5px rgba(255, 210, 31, 1);
    }
  }

  &.success {
    ::after {
      background-color: rgba(1, 225, 123, 1);
      box-shadow: 0 0 5px rgba(1, 225, 123, 1);
    }
  }
`
const MessageWrap = styled('div')`
  flex: 1;
  font-size: 13px;
  /* line-height: 1.4; */
  /* padding: 2px 0 0; */
`
const CloseWrap = styled('div')`
  padding: 2px;
  font-size: 0;
  line-height: 0;
  cursor: pointer;
  margin-left: 10px;
  border-radius: 4px;

  &:hover {
    background: ${(props) => props.theme.color.text20};
  }
  svg {
    margin: 0;
    width: 18px;
    height: 18px;
  }
`
const LinkWrap = styled('div')`
  margin-top: 4px;
  a {
    color: ${(props) => props.theme.color.textHighlight};
    font-size: 12px;
    line-height: 1.4;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
`

const DismissButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <CloseWrap onClick={onClick}>
      <SvgClose fontSize="inherit" />
    </CloseWrap>
  )
}

const overrideOptions: ToastOptions = {
  position: 'bottom-center',
  duration: 4000,
  style: {
    overflow: 'hidden',
    borderRadius: '8px',
    background: '#2b3139',
    boxShadow: `0px 8px 10px 0px rgba(0, 0, 0, 0.2),
    0px 6px 30px 0px rgba(0, 0, 0, 0.12),
    0px 16px 24px 0px rgba(0, 0, 0, 0.14)`,
  },
}

const toastify = {
  success(message: string, options?: ToastOptions | undefined) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const toastId = toast(
      <ToastWrap className="success">
        <SvgSuccess />
        <MessageWrap>{message}</MessageWrap>
        {/* <DismissButton onClick={() => toast.dismiss(toastId)} /> */}
      </ToastWrap>,
      {
        ...overrideOptions,
        ...options,
      },
    )
  },
  error(message: string, options?: ToastOptions | undefined) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const toastId = toast(
      <ToastWrap className="error">
        <SvgError />
        <MessageWrap>{message}</MessageWrap>
        {/* <DismissButton onClick={() => toast.dismiss(toastId)} /> */}
      </ToastWrap>,
      {
        ...overrideOptions,
        duration: 6000,
        ...options,
      },
    )
  },
  warn(message: string, options?: ToastOptions | undefined) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const toastId = toast(
      <ToastWrap className="warn">
        <SvgWarning />
        <MessageWrap>{message}</MessageWrap>
        {/* <DismissButton onClick={() => toast.dismiss(toastId)} /> */}
      </ToastWrap>,
      {
        ...overrideOptions,
        ...options,
      },
    )
  },
  info(message: string, options?: ToastOptions | undefined) {
    const toastId = toast(
      <ToastWrap>
        <SvgInfo />
        <MessageWrap>{message}</MessageWrap>
        <DismissButton onClick={() => toast.dismiss(toastId)} />
      </ToastWrap>,
      {
        ...overrideOptions,
        ...options,
      },
    )
  },
  transaction(
    message: string,
    link: string,
    options?: ToastOptions | undefined,
  ) {
    const toastId = toast(
      <ToastWrap>
        <SvgSuccess />
        <MessageWrap>
          {message}
          <LinkWrap>
            <a href={link} target="_blank" rel="noreferrer">
              View On Explorer
            </a>
          </LinkWrap>
        </MessageWrap>
        <DismissButton onClick={() => toast.dismiss(toastId)} />
      </ToastWrap>,
      {
        ...overrideOptions,
        ...options,
      },
    )
  },
}

export default toastify
